exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input--2Kcfh {\n\tpadding-bottom: 20px;\n}", ""]);

// Exports
exports.locals = {
	"input": "input--2Kcfh"
};